import React, { useEffect, useMemo, useRef, useState } from "react";

import "react-18-image-lightbox/style.css";
import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";

import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";
import { CapacidadesHotel } from "../capacidades/CapacidadesHotel";
import { formatearNumero } from "../../components/helpers/formatearNumero";
import { usePriceToSelectedCurrency } from "../../hooks/usePriceToSelectedCurrency";

import Spinner from "../../components/helpers/Spinner";
import Swal from "sweetalert2";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Lazy } from "swiper";
import "swiper/css/lazy";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Calendar from "react-calendar";

import getEveryDayBetween2Dates from "../../helpers/getEveryDayBetween2Dates";
import { getEachDayPrice } from "../../helpers/getEachDayPrice";
import { transformDatesToSlash } from "../../helpers/transformDatesToSlash";
import useCurrencyPrices from "../../hooks/useCurrencyPrices";
import { calcularMinimaDisponibilidad } from "../calendario-reserva/calcularMinimaDisponibilidad";

import { getPriceAditionalServicePerDay } from "../calendario-reserva/getPriceAditionalServicePerDay";
import { DateIsBetween2Dates } from "../../helpers/DateIsBetween2Dates";
import { ModalCupon } from "./ModalCupon";

import { useNavigate } from "react-router-dom";
import {
    Habitacion,
    Props,
    reserva,
    Reservas,
    Tour,
} from "../../components/helpers/types/modal_habitacion";
import { huespedesProps } from "../../components/helpers/types/modal_tour";
import ModalHuespedes from "../../components/helpers/ModalHuespedes";
import { useAppSelector } from "../../hooks/hooks";
import ModalHabitacionAllTours from "./ModalHabitacionAllTours";
import ModalHabitacionOneTour from "./ModalHabitacionOneTour";

export const ModalHabitacion = ({
    modalVisible,
    setModalVisible,
    id_habitacion,
    fecha_ingreso,
    fecha_salida,
    total_huespedes,
}: Props) => {
    const { tipo_moneda, id: casa_id } = useAppSelector(
        (state) => state.landing_house.house,
    );

    // --- LÓGICA DE COLORES DINÁMICOS ---
    const isGlamping = casa_id === 378;
    const textAccentClass = isGlamping ? "text-[#4a4641]" : "text-[#1C4CBB]";
    const borderAccentClass = isGlamping
        ? "border-[#4a4641]"
        : "border-[#1C4CBB]";
    // El celeste original (#029BFC) también pasará a café oscuro en glamping
    const bgButtonClass = isGlamping ? "bg-[#4a4641]" : "bg-[#029BFC]";
    const textSecondaryClass = isGlamping ? "text-[#4a4641]" : "text-[#029BFC]";
    const swalColor = isGlamping ? "#4a4641" : "#029BFC";
    const checkboxClass = isGlamping ? "accent-[#4a4641]" : "accent-[#1C4CBB]";
    // -----------------------------------

    const navigate = useNavigate();
    const [modalCalendar, setModalCalendar] = useState<boolean>(false);
    const [modalHuespedes, setModalHuespedes] = useState<boolean>(false);
    const [reserveVisible, setReserveVisible] = useState<boolean>(false);
    const [allDatesSelected, setAllDatesSelected] = useState<Date[]>([]);
    const [errorReserve, setErrorReserve] = useState<string | null>(null);
    const [tourSelected, setTourSelected] = useState<Tour>();
    const [view, setView] = useState<string>("habitacion");
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingHabitacion, setLoadingHabitacion] = useState<boolean>(false);
    const [tours, setTours] = useState<Tour[]>();
    const [cupon, setCupon] = useState(0);
    const { SELECTED_CURRENCY } = useCurrencyPrices();
    const [checkedInputs, setCheckedInputs] = useState<any[]>([]);
    const [reserva, setReserva] = useState<reserva>({
        precio_alquiler: 0,
        garantia: 0,
        descuento_estadia: 0,
        descuento_cupon: 0,
        total_servicios_adicionales: 0,
        servicios_adicionales: [],
        reserva_tours: [],
        precio_total_reserva: 0,
    });
    const scrollRef = useRef<HTMLDivElement>(null);
    const [habitacion, setHabitacion] = useState<Habitacion>({
        id: 0,
        nombre: "",
        descripcion: "",
        banner: "",
        precio_base: "",
        personas: "",
        plan: 2,
        mascotas: "",
        estadia_minima: 0,
        banos: "",
        camas: "",
        landing: 0,
        check_in: "",
        check_out: "",
        id_hotel: 0,
        tipo_garantia: "",
        garantia: "",
        casa: {
            id: 0,
            nombre: "",
        },
        hotel_habitaciones_imagenes: [],
        disponibilidades: {
            arrayDias: [],
            arrayFechas: [],
        },
        precios_variables: [],
        hotel_estadias_minimas: [],
        servicios_adicionales: [],
        descuentos_tiempos: [],
        personas_adicionales: [],
        pedidos: {
            arrayFechasPedido: [],
        },
    });

    const modalRef = useRef<HTMLDivElement>(null);
    const modalRefCalendar = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (modalVisible) {
            getOneHabitacion();
        }
    }, [modalVisible]);

    const getOneHabitacion = async () => {
        setLoadingHabitacion(true);
        const response = await fetchAxiosToken({
            url: `/hotel_habitaciones/detalle/${id_habitacion}`,
            method: "get",
        });

        setHabitacion(response);
        setLoadingHabitacion(false);
    };

    const getTours = async () => {
        setLoading(true);

        try {
            const response = await fetchAxiosToken({
                url: `/hoteles_tours/getAllByHotel/${casa_id}?query=Publicado`,
                method: "get",
            });

            setTours(response);
        } catch (error) {
            console.error("Error al obtener habitaciones:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (view === "all_tours") {
            getTours();
        }
    }, [view]);

    // Función para manejar clics fuera del modal
    const handleClickOutside = (event: MouseEvent) => {
        if (
            modalRef.current &&
            !modalRef.current.contains(event.target as Node)
        ) {
            setModalCalendar(false); // Cierra el modal
        }
    };

    const handleClickOutsideHuespedes = (event: MouseEvent) => {
        if (
            modalRefCalendar.current &&
            !modalRefCalendar.current.contains(event.target as Node)
        ) {
            setModalHuespedes(false); // Cierra el modal
        }
    };

    const [dataReseve, setDataReserve] = useState<{
        fecha_inicial: string;
        fecha_final: string;
        huespedes: number;
    }>({
        fecha_inicial: "Selecciona una fecha",
        fecha_final: "Selecciona una fecha",
        huespedes: 1,
    });

    const parseDateFromString = (
        dateStr: string,
        isEndDate = false,
    ): Date | null => {
        if (!dateStr) return null;
        const [day, month, year] = dateStr.split("/").map(Number);
        if (
            !day ||
            !month ||
            !year ||
            day < 1 ||
            day > 31 ||
            month < 1 ||
            month > 12
        ) {
            console.error("Fecha inválida:", dateStr);
            return null;
        }

        const date = new Date(year, month - 1, day);

        if (isEndDate) {
            date.setHours(23, 59, 59, 999); // Establecer hora a 23:59:59.999
        }
        return date;
    };

    const handleClick = (tour: Tour) => {
        setView("tour");
        setTourSelected(tour);
    };

    useEffect(() => {
        if (!loadingHabitacion) {
            let fecha_inicio_str = "Selecciona una fecha";
            let fecha_final_str = "Selecciona una fecha";
            if (fecha_ingreso !== "" && fecha_salida !== "") {
                fecha_inicio_str = fecha_ingreso;
                fecha_final_str = fecha_salida;
                let startDate: Date | null = null;
                let endDate: Date | null = null;
                if (fecha_ingreso) {
                    startDate = parseDateFromString(fecha_ingreso);
                }
                if (fecha_salida) {
                    endDate = parseDateFromString(fecha_salida, true); // Pasar true para ajustar la fecha final
                }

                if (startDate && endDate) {
                    setDatesSelected({
                        fecha_inicial: startDate,
                        fecha_final: endDate,
                    });

                    onChangeCalendar([startDate, endDate]);
                }
            }

            setDataReserve({
                fecha_inicial: fecha_inicio_str,
                fecha_final: fecha_final_str,
                huespedes: total_huespedes,
            });
        }
    }, [loadingHabitacion]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalCalendar) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalCalendar]);

    useEffect(() => {
        // Agregar el evento cuando el modal está activo
        if (modalHuespedes) {
            document.addEventListener("mousedown", handleClickOutsideHuespedes);
        }

        // Eliminar el evento al desmontar o cuando el modal se cierra
        return () => {
            document.removeEventListener(
                "mousedown",
                handleClickOutsideHuespedes,
            );
        };
    }, [modalHuespedes]);

    const [datesSelected, setDatesSelected] = useState<{
        fecha_inicial: Date;
        fecha_final: Date;
    } | null>(null);

    const { price_to_currency } = usePriceToSelectedCurrency();

    const formatDate = (date: Date) => {
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Mes empieza desde 0
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const [huespedes, setHuespedes] = useState({
        adultos: 1,
        ninos: 0,
        mascotas: 0,
    });

    const onChangeCalendar = (twoDates: Date[]) => {
        const fecha_inicial = formatDate(twoDates[0]);
        const fecha_final = formatDate(twoDates[1]);

        // Actualizar estados
        setDatesSelected({
            fecha_inicial: twoDates[0],
            fecha_final: twoDates[1],
        });

        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial,
            fecha_final,
        }));

        setModalCalendar(false);
        setReserveVisible(true);
        const all_dates_selected = getEveryDayBetween2Dates({
            array_fechas: twoDates,
        });

        const all_dates_selectedTotal = getEveryDayBetween2Dates({
            array_fechas: twoDates,
        });
        const allDaysSelected = getEveryDayBetween2Dates({
            array_fechas: twoDates,
        }).map((date) => date.getDay());

        let precioVariblePorSemana = 0;

        if (habitacion?.precio_base) {
            let total_alquiler = all_dates_selected.reduce(
                (acc, currentDate) => {
                    return (acc += getEachDayPrice({
                        current_day: currentDate,
                        house_variable_prices:
                            2 > 1 ? habitacion.precios_variables : [],
                        base_price: Number(habitacion.precio_base),
                    }));
                },
                0,
            );

            const isAvailable = calcularMinimaDisponibilidad({
                minimaDisponibilidad: habitacion.hotel_estadias_minimas,
                //Tomo el primer y el ultimo día reservado
                selected_dates: [
                    all_dates_selected[0],
                    all_dates_selected[all_dates_selected.length - 1],
                ],
                estadia_maxima: 0,
                estadia_minima: habitacion.estadia_minima,
            });

            if (all_dates_selected.length > 1) {
                all_dates_selected.pop();
            }

            setAllDatesSelected(all_dates_selected);

            const arrayFechas = habitacion.disponibilidades.arrayFechas.map(
                (fecha) => {
                    const transformFecha = transformDatesToSlash({
                        date: fecha.fecha,
                    });

                    return new Date(transformFecha).getTime();
                },
            );

            const arrayFechasPedidos = habitacion.pedidos.arrayFechasPedido.map(
                (fecha: Reservas) => {
                    const transformFecha = transformDatesToSlash({
                        date: fecha.fecha,
                    });

                    return new Date(transformFecha).getTime();
                },
            );

            const all_days_selected = all_dates_selected.map((date) =>
                date.getDay(),
            );

            const { arrayDias } = habitacion.disponibilidades;
            if (
                all_dates_selected.some((date) =>
                    arrayFechasPedidos.includes(date.getTime()),
                ) ||
                all_dates_selected.some((date) =>
                    arrayFechas.includes(date.getTime()),
                ) ||
                all_days_selected.some((day) =>
                    arrayDias.some(
                        (dia) =>
                            dia.dia === day &&
                            twoDates[1] <= new Date(dia.fecha_final) &&
                            twoDates[0] >= new Date(dia.fecha_inicio),
                    ),
                )
            ) {
                setErrorReserve("No puedes seleccionar fechas no disponibles");
            } else {
                if (isAvailable.some(({ available }) => available === false)) {
                    const response = isAvailable.find(
                        ({ available }) => available === false,
                    );
                    setErrorReserve(response?.message || null);
                } else {
                    setErrorReserve(null);
                }
            }

            setReserva({
                ...reserva,
                garantia:
                    habitacion.tipo_garantia === "efectivo"
                        ? 0
                        : Number(habitacion?.garantia),
                precio_alquiler:
                    precioVariblePorSemana > 0
                        ? precioVariblePorSemana
                        : total_alquiler,
            });

            const newCheckedInputs = habitacion.servicios_adicionales.filter(
                (service: any) => service.opcional === "No",
            );

            setCheckedInputs(
                newCheckedInputs.map((input: any) => Number(input.id)),
            );

            let servicios_adicionales: any = [];
            let total_servicios_adicionales = 0;
            habitacion.servicios_adicionales.forEach((currentService) => {
                const service_final_price = getPriceAditionalServicePerDay({
                    dia_inicial: new Date(fecha_inicial),
                    dia_final: new Date(fecha_final),
                    servicio_adicional: currentService,
                });
                if (currentService.opcional === "No") {
                    total_servicios_adicionales += service_final_price;
                }

                servicios_adicionales.push({
                    id: currentService.id,
                    nombre: currentService.nombre,
                    precio: service_final_price,
                    opcional: currentService.opcional,
                });
            });

            const total_nights = all_dates_selected.length;
            let descuento_estadia = 0;
            const matchDiscountFecha = habitacion.descuentos_tiempos.find(
                (descuento) => {
                    if (
                        total_nights >= descuento.dia_inicio - 1 &&
                        total_nights <= descuento.dia_final - 1 &&
                        descuento.tipo === "Fecha"
                    ) {
                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: descuento.fecha_inicio,
                            }),
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: descuento.fecha_final,
                            }),
                        );

                        if (
                            all_dates_selected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                )
                                    return true;
                            })
                        ) {
                            return descuento;
                        }
                    }
                },
            );

            if (matchDiscountFecha) {
                descuento_estadia = Number(matchDiscountFecha.descuento);
            } else {
                const matchDiscountSiempre = habitacion.descuentos_tiempos.find(
                    (descuento) =>
                        total_nights >= descuento.dia_inicio - 1 &&
                        total_nights <= descuento.dia_final - 1 &&
                        descuento.tipo === "Siempre",
                );

                if (matchDiscountSiempre) {
                    descuento_estadia = Number(matchDiscountSiempre.descuento);
                } else {
                    descuento_estadia = 0;
                }
            }

            const matchPersonasAdicionalesFecha =
                habitacion.personas_adicionales.find((rango_persona) => {
                    if (
                        Number(dataReseve.huespedes) >=
                            Number(rango_persona.rango_inicio) &&
                        Number(dataReseve.huespedes) <=
                            Number(rango_persona.rango_final) &&
                        rango_persona.tipo === "Fecha"
                    ) {
                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_inicio,
                            }),
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_final,
                            }),
                        );

                        if (
                            all_dates_selected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                ) {
                                    return true;
                                }
                            })
                        ) {
                            return rango_persona;
                        }
                    }
                });
            let precio_personas_adicionales = 0;

            if (matchPersonasAdicionalesFecha) {
                precio_personas_adicionales =
                    total_nights * Number(matchPersonasAdicionalesFecha.precio);
            } else {
                const matchPersonasAdicionalesSiempre =
                    habitacion.personas_adicionales.find(
                        (rango_persona) =>
                            Number(dataReseve.huespedes) >=
                                Number(rango_persona.rango_inicio) &&
                            Number(dataReseve.huespedes) <=
                                Number(rango_persona.rango_final) &&
                            rango_persona.tipo === "Siempre",
                    );

                if (matchPersonasAdicionalesSiempre) {
                    precio_personas_adicionales =
                        total_nights *
                        Number(matchPersonasAdicionalesSiempre.precio);
                } else {
                    precio_personas_adicionales = 0;
                }
            }
            total_alquiler += precio_personas_adicionales;
            const garantia =
                habitacion.tipo_garantia === "efectivo"
                    ? 0
                    : Number(habitacion?.garantia);

            const total_tours = reserva.reserva_tours?.reduce(
                (total, tour) => total + (tour.precio_tour || 0),
                0,
            );

            let reservaFinal =
                price_to_currency(total_alquiler) +
                price_to_currency(garantia) +
                price_to_currency(total_tours) +
                price_to_currency(total_servicios_adicionales) -
                price_to_currency(descuento_estadia);

            setReserva({
                ...reserva,
                garantia,
                precio_alquiler:
                    precioVariblePorSemana > 0
                        ? precioVariblePorSemana
                        : total_alquiler,
                servicios_adicionales,
                total_servicios_adicionales,
                descuento_estadia,
                precio_total_reserva: reservaFinal,
            });
        }
    };

    useEffect(() => {
        const services = habitacion.servicios_adicionales.filter((service) =>
            checkedInputs.includes(service.id),
        );

        const final_price = services.reduce((acc, currentService, idx) => {
            const service_final_price = getPriceAditionalServicePerDay({
                dia_inicial: datesSelected?.fecha_inicial || new Date(),
                dia_final: datesSelected?.fecha_final || new Date(),
                servicio_adicional: currentService,
            });

            return (acc += service_final_price);
        }, 0);

        const total_tours = reserva.reserva_tours?.reduce(
            (total, tour) => total + (tour.precio_tour || 0),
            0,
        );

        let reservaFinal =
            price_to_currency(reserva.precio_alquiler) +
            price_to_currency(reserva.garantia) +
            price_to_currency(total_tours) +
            price_to_currency(final_price) -
            price_to_currency(reserva.descuento_estadia);

        setReserva({
            ...reserva,
            total_servicios_adicionales: price_to_currency(final_price),
            precio_total_reserva: reservaFinal,
        });
    }, [checkedInputs]);

    const handleCheckbox = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.checked)
            setCheckedInputs((prev) => [...prev, Number(e.target.value)]);
        else
            setCheckedInputs((prev) =>
                prev.filter((input) => input !== Number(e.target.value)),
            );
    };

    const handleDeleteFechas = () => {
        setDataReserve((prev) => ({
            ...prev,
            fecha_inicial: "Selecciona una fecha",
            fecha_final: "Selecciona una fecha",
        }));
        setReserveVisible(false);
        setDatesSelected(null);
    };

    const handleModalHuespedes = () => {
        if (modalHuespedes) {
            setModalHuespedes(false); // Cierra el modal si ya está abierto
        } else {
            setModalHuespedes(true); // Abre el modal si está cerrado
        }
    };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        const newValue = inputValue !== "" ? Number(inputValue) : "";

        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = {
                ...prevHuespedes,
                [event.target.name]: newValue,
            };

            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    useEffect(() => {
        let total_nights = allDatesSelected.length;

        if (total_nights > 0) {
            let total_alquiler = allDatesSelected.reduce((acc, currentDate) => {
                return (acc += getEachDayPrice({
                    current_day: currentDate,
                    house_variable_prices:
                        2 > 1 ? habitacion.precios_variables : [],
                    base_price: Number(habitacion.precio_base),
                }));
            }, 0);

            const matchPersonasAdicionalesFecha =
                habitacion.personas_adicionales.find((rango_persona) => {
                    if (
                        Number(dataReseve.huespedes) >=
                            Number(rango_persona.rango_inicio) &&
                        Number(dataReseve.huespedes) <=
                            Number(rango_persona.rango_final) &&
                        rango_persona.tipo === "Fecha"
                    ) {
                        const nueva_fecha_inicio = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_inicio,
                            }),
                        );
                        const nueva_fecha_final = new Date(
                            transformDatesToSlash({
                                date: rango_persona.fecha_final,
                            }),
                        );

                        if (
                            allDatesSelected.some((dateSelected) => {
                                if (
                                    DateIsBetween2Dates({
                                        fecha_evaluada: dateSelected,
                                        fecha_inicio: nueva_fecha_inicio,
                                        fecha_final: nueva_fecha_final,
                                    })
                                ) {
                                    return true;
                                }
                            })
                        ) {
                            return rango_persona;
                        }
                    }
                });
            let precio_personas_adicionales = 0;

            if (matchPersonasAdicionalesFecha) {
                precio_personas_adicionales =
                    total_nights * Number(matchPersonasAdicionalesFecha.precio);
            } else {
                const matchPersonasAdicionalesSiempre =
                    habitacion.personas_adicionales.find(
                        (rango_persona) =>
                            Number(dataReseve.huespedes) >=
                                Number(rango_persona.rango_inicio) &&
                            Number(dataReseve.huespedes) <=
                                Number(rango_persona.rango_final) &&
                            rango_persona.tipo === "Siempre",
                    );

                if (matchPersonasAdicionalesSiempre) {
                    precio_personas_adicionales =
                        total_nights *
                        Number(matchPersonasAdicionalesSiempre.precio);
                } else {
                    precio_personas_adicionales = 0;
                }
            }

            total_alquiler = total_alquiler + precio_personas_adicionales;

            const total_tours = reserva.reserva_tours?.reduce(
                (total, tour) => total + (tour.precio_tour || 0),
                0,
            );

            let reservaFinal =
                price_to_currency(total_alquiler) +
                price_to_currency(reserva.garantia) +
                price_to_currency(total_tours) +
                price_to_currency(reserva.total_servicios_adicionales) -
                price_to_currency(reserva.descuento_estadia);

            setReserva({
                ...reserva,
                precio_alquiler: price_to_currency(total_alquiler),
                precio_total_reserva: reservaFinal,
            });
        }
    }, [dataReseve.huespedes]);

    useEffect(() => {
        console.log(cupon);
    }, [cupon]);

    const handleInputClick = ({ name, action }: huespedesProps) => {
        setHuespedes((prevHuespedes) => {
            const updatedHuespedes = { ...prevHuespedes };

            const totalHuespedesActual =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            if (action === "sumar") {
                if (totalHuespedesActual < Number(habitacion.personas)) {
                    switch (name) {
                        case "adultos":
                        case "ninos":
                        case "mascotas":
                            updatedHuespedes[name] += 1;
                            break;
                        default:
                            break;
                    }
                }
            } else {
                switch (name) {
                    case "adultos":
                        updatedHuespedes[name] = Math.max(
                            1,
                            updatedHuespedes[name] - 1,
                        );
                        break;
                    case "ninos":
                    case "mascotas":
                        updatedHuespedes[name] = Math.max(
                            0,
                            updatedHuespedes[name] - 1,
                        );
                        break;
                    default:
                        break;
                }
            }

            const totalHuespedes =
                (updatedHuespedes.adultos || 0) + (updatedHuespedes.ninos || 0);

            setDataReserve((prevData) => ({
                ...prevData,
                huespedes: totalHuespedes,
            }));

            return updatedHuespedes;
        });
    };

    const handleSubmit = () => {
        const TOTAL_HUESPEDES =
            Number(huespedes.adultos) + Number(huespedes.ninos);
        if (Number(huespedes.adultos) < 1) {
            return Swal.fire({
                confirmButtonColor: swalColor,
                iconColor: swalColor,
                title: "Por favor primero indica la cantidad de huéspedes",
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }
        if (TOTAL_HUESPEDES > Number(habitacion.personas)) {
            return Swal.fire({
                confirmButtonColor: swalColor,
                iconColor: swalColor,
                title: `Solo se permiten hasta ${habitacion.personas} personas incluido niños y adultos`,
                icon: "warning",
                confirmButtonText: "Aceptar",
            });
        }

        const servicios_adicionales_seleccionados =
            reserva.servicios_adicionales.filter((servicio) =>
                checkedInputs.includes(servicio.id),
            );

        localStorage.setItem(
            "reserva",
            JSON.stringify({
                id_casa: habitacion.id_hotel,
                precio_alquiler: price_to_currency(reserva.precio_alquiler),
                garantia: price_to_currency(Number(reserva.garantia)),
                tipo_garantia: habitacion.tipo_garantia,

                descuento_estadia: reserva.descuento_estadia,
                precio_servicios_adicionales:
                    reserva.total_servicios_adicionales,
                precio_total: reserva.precio_total_reserva - cupon,
                huespedes: {
                    adultos: Number(huespedes.adultos),
                    mascotas: Number(huespedes.mascotas),
                    ninos: Number(huespedes.ninos),
                },
                dates_selected: {
                    final_date: datesSelected?.fecha_final,
                    initial_date: datesSelected?.fecha_inicial,
                },
                servicios_adicionales: servicios_adicionales_seleccionados.map(
                    (service) => {
                        return {
                            ...service,
                            precio_final: price_to_currency(service.precio),
                        };
                    },
                ),
                datos_alojamiento: {
                    id_habitacion: habitacion.id,
                    habitacion: habitacion.nombre,
                    casa: habitacion.casa.nombre,
                    id_casa: habitacion.casa.id,
                    moneda: SELECTED_CURRENCY,
                },
                datos_tour: reserva.reserva_tours,
                cupon: cupon,
            }),
        );

        navigate("/checkout-hotel/");
    };

    const agregarAMPM = (hora: string) => {
        const [h, m] = hora.split(":");
        const horaNum = parseInt(h, 10);
        const periodo = horaNum >= 12 ? "PM" : "AM";
        return `${h}:${m} ${periodo}`;
    };

    const calculateDisabledTiles = React.useMemo(
        () =>
            (date: Date): boolean => {
                if (habitacion) {
                    const disponibilidadesFechasPedidos =
                        habitacion.pedidos.arrayFechasPedido.some(
                            (fecha: Reservas) => {
                                return (
                                    date.getTime() ===
                                    new Date(
                                        fecha.fecha + "T00:00:00",
                                    ).getTime()
                                );
                            },
                        );

                    if (disponibilidadesFechasPedidos)
                        return disponibilidadesFechasPedidos;

                    const disponibilidadesDias =
                        habitacion.disponibilidades.arrayDias;

                    if (
                        disponibilidadesDias.some(
                            (dia) =>
                                dia.dia === date.getDay() &&
                                date <= new Date(dia.fecha_final) &&
                                date >= new Date(dia.fecha_inicio),
                        )
                    )
                        return true;
                }
                return false;
            },
        [habitacion],
    );

    const handleDeleteTour = (tour: any, index: number) => {
        setReserva((prev) => {
            const nuevoTours = [...prev.reserva_tours];
            nuevoTours.splice(index, 1);

            const precioTour = Number(
                String(tour.precio_tour).replace(/[^\d.-]/g, ""),
            );

            return {
                ...prev,
                reserva_tours: nuevoTours,
                precio_total_reserva:
                    Number(prev.precio_total_reserva) - precioTour,
            };
        });
    };

    const formatearFecha = (fecha: string): string => {
        const [anio, mes, dia] = fecha.split("-");
        return `${dia}/${mes}/${anio}`;
    };

    return (
        <ResponsiveModalAbsolute
            scrollRef={scrollRef}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            max_width={90}
        >
            {view === "habitacion" && (
                <div className="relative flex flex-col items-center justify-center w-full gap-4 p-4 mx-auto ">
                    {modalCalendar && (
                        <div
                            ref={modalRef}
                            className="absolute z-50 flex flex-col items-center justify-center w-11/12 gap-4 p-1 bg-white md:w-1/3 lg:top-20 top-96 h-96 shadow-lg border rounded-md"
                        >
                            <Calendar
                                selectRange={true}
                                onChange={onChangeCalendar}
                                minDate={new Date()}
                                tileDisabled={({
                                    activeStartDate,
                                    date,
                                    view,
                                }) => calculateDisabledTiles(date)}
                                value={
                                    datesSelected
                                        ? [
                                              datesSelected.fecha_inicial,
                                              datesSelected.fecha_final,
                                          ]
                                        : undefined
                                }
                            />

                            <div
                                onClick={handleDeleteFechas}
                                className={`underline cursor-pointer ${textAccentClass} justify-end w-full text-right px-5 pb-2 transition-colors duration-300`}
                            >
                                Borrar fechas
                            </div>
                        </div>
                    )}

                    <h2
                        className={`2xl:text-4xl text-3xl ${textAccentClass} text-center font-medium transition-colors duration-300`}
                    >
                        Habitación {habitacion?.nombre}
                    </h2>
                    <hr className="w-full bg-gray-300" />
                    {loadingHabitacion ? (
                        <>
                            <Spinner />
                        </>
                    ) : (
                        <div className="flex flex-col items-center justify-center w-full h-full gap-4 p-4 mx-auto ">
                            {habitacion && (
                                <div
                                    key={`habitacion-${habitacion.id}`}
                                    className={` w-full flex lg:flex-row flex-col justify-start px-5 items-start gap-10`}
                                >
                                    <div className="w-full lg:w-1/2">
                                        <Swiper
                                            key={habitacion.banner}
                                            modules={[Navigation, Lazy]}
                                            slidesPerView={1}
                                            watchSlidesProgress
                                            lazy={true}
                                            navigation
                                            rewind={true}
                                            loop={true}
                                        >
                                            <SwiperSlide
                                                key={habitacion.banner}
                                                className="cursor-pointer"
                                            >
                                                <img
                                                    loading="lazy"
                                                    className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                    alt="Imagen del producto"
                                                    data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${habitacion.banner}`}
                                                    data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${habitacion.banner}`}
                                                />

                                                <div className="swiper-lazy-preloader">
                                                    <div className="flex flex-col w-full h-40 gap-2 p-3 bg-gray-200 lg:h-64">
                                                        <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                        <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                        <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                            {habitacion?.hotel_habitaciones_imagenes?.map(
                                                (imagen) => (
                                                    <SwiperSlide
                                                        key={imagen.id}
                                                    >
                                                        <img
                                                            loading="lazy"
                                                            className=" lg:h-[50vh] h-[30vh] rounded-md swiper-lazy mx-auto"
                                                            alt="Imagen del producto"
                                                            data-src={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${imagen.imagen}`}
                                                            data-srcset={`${process.env.REACT_APP_PROXY_ARCHIVOS}/blu/v1/hotel_habitaciones/getImage/${imagen.imagen}`}
                                                        />
                                                        <div className="swiper-lazy-preloader">
                                                            <div className="flex flex-col w-auto lg:h-[65vh] h-[30vh] gap-2 p-3 bg-gray-200">
                                                                <div className="bg-slate-50 w-full h-[80%] rounded-xl"></div>
                                                                <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                                <div className="bg-slate-50 w-full h-[10%] rounded-full"></div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                ),
                                            )}
                                        </Swiper>
                                    </div>

                                    <div className="flex flex-col items-center justify-center w-full gap-4 lg:w-1/2">
                                        {" "}
                                        <div className="flex flex-col items-center justify-center gap-5 lg:flex-row lg:gap-10">
                                            <div
                                                className={`text-lg text-center ${textAccentClass} align-middle transition-colors duration-300`}
                                            >
                                                <p className="font-light select-none">
                                                    <span className="font-semibold">{`${SELECTED_CURRENCY} ${formatearNumero(
                                                        price_to_currency(
                                                            Number(
                                                                habitacion?.precio_base,
                                                            ),
                                                        ),
                                                    )} `}</span>{" "}
                                                    /por noche
                                                </p>
                                            </div>

                                            <div
                                                className={`h-20 border-l-2 ${borderAccentClass} hidden lg:flex transition-colors duration-300`}
                                            ></div>

                                            <div className="flex flex-col items-center justify-center ">
                                                <CapacidadesHotel
                                                    personas={
                                                        habitacion?.personas ||
                                                        ""
                                                    }
                                                    mascotas={
                                                        habitacion?.mascotas ||
                                                        ""
                                                    }
                                                    banos={
                                                        habitacion?.banos || ""
                                                    }
                                                    camas={
                                                        habitacion?.camas || ""
                                                    }
                                                    id_habitacion={
                                                        habitacion?.id || 0
                                                    }
                                                    toggleButton={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-col items-center justify-center w-full px-3 py-5 border border-gray-200 rounded-lg shadow-lg md:px-10 md:w-11/12 ">
                                            <div
                                                className={`text-xl text-center font-semibold ${textSecondaryClass} transition-colors duration-300`}
                                            >
                                                {!reserveVisible &&
                                                    "Elije tus fechas para ver el precio de tu reserva"}
                                            </div>
                                            <div className="w-5/6 mx-auto mt-4 border-2 border-gray-500 rounded-lg ">
                                                <div className="flex border-b-2 border-gray-500 divide-x-2 divide-gray-500">
                                                    <div
                                                        onClick={() =>
                                                            setModalCalendar(
                                                                !modalCalendar,
                                                            )
                                                        }
                                                        className="flex-1 p-4 cursor-pointer"
                                                    >
                                                        <p className="text-xs font-medium text-gray-800 uppercase">
                                                            LLEGADA
                                                        </p>
                                                        <p
                                                            className={`mt-1 text-sm font-semibold ${
                                                                dataReseve.fecha_inicial ===
                                                                "Selecciona una fecha"
                                                                    ? "text-gray-500"
                                                                    : "text-gray-800"
                                                            }`}
                                                        >
                                                            {
                                                                dataReseve.fecha_inicial
                                                            }
                                                        </p>
                                                    </div>

                                                    <div
                                                        onClick={() =>
                                                            setModalCalendar(
                                                                !modalCalendar,
                                                            )
                                                        }
                                                        className="flex-1 p-4 cursor-pointer"
                                                    >
                                                        <p className="text-xs font-medium text-gray-800 uppercase">
                                                            SALIDA
                                                        </p>
                                                        <p
                                                            className={`mt-1 text-sm font-semibold ${
                                                                dataReseve.fecha_final ===
                                                                "Selecciona una fecha"
                                                                    ? "text-gray-500"
                                                                    : "text-gray-800"
                                                            } `}
                                                        >
                                                            {
                                                                dataReseve.fecha_final
                                                            }
                                                        </p>
                                                    </div>
                                                </div>

                                                <div
                                                    onClick={() =>
                                                        handleModalHuespedes()
                                                    }
                                                    className="relative flex items-center justify-between p-4 cursor-pointer "
                                                >
                                                    {modalHuespedes && (
                                                        <ModalHuespedes
                                                            modalRefCalendar={
                                                                modalRefCalendar
                                                            }
                                                            handleInputClick={
                                                                handleInputClick
                                                            }
                                                            huespedes={
                                                                huespedes
                                                            }
                                                            handleInputChange={
                                                                handleInputChange
                                                            }
                                                        />
                                                    )}

                                                    <div>
                                                        <p className="text-xs font-medium text-gray-800 uppercase">
                                                            HUÉSPEDES
                                                        </p>
                                                        <p className="mt-1 text-sm font-semibold text-gray-800">
                                                            {
                                                                dataReseve.huespedes
                                                            }{" "}
                                                            huésped
                                                        </p>
                                                    </div>
                                                    <div className="text-gray-500">
                                                        {modalHuespedes ? (
                                                            <svg
                                                                className="w-5 h-5 "
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    strokeWidth="2"
                                                                    d="M5 15l7-7 7 7"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg
                                                                className="w-5 h-5 "
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth="2"
                                                                stroke="currentColor"
                                                                fill="none"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                {" "}
                                                                <path
                                                                    stroke="none"
                                                                    d="M0 0h24v24H0z"
                                                                />{" "}
                                                                <polyline points="6 9 12 15 18 9" />
                                                            </svg>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {errorReserve ? (
                                                <div className="font-medium text-center text-red-500">
                                                    {errorReserve}
                                                </div>
                                            ) : (
                                                <>
                                                    {reserveVisible && (
                                                        <div
                                                            onClick={
                                                                handleSubmit
                                                            }
                                                            className={`w-5/6 p-3 ${bgButtonClass} text-white rounded-lg mt-4 cursor-pointer font-bold text-center hover:scale-105 transition-all duration-300 mb-5`}
                                                        >
                                                            {reserveVisible
                                                                ? "Reservar"
                                                                : "Comprobar disponibilidad"}
                                                        </div>
                                                    )}

                                                    {reserveVisible && (
                                                        <>
                                                            <div
                                                                className={`flex justify-between w-full py-2 border-y ${borderAccentClass} ${textAccentClass} transition-colors duration-300`}
                                                            >
                                                                <span className="mt-2 font-semibold">
                                                                    Precio de
                                                                    alquiler{" "}
                                                                </span>
                                                                <span className="mt-2 font-semibold">
                                                                    {formatearNumero(
                                                                        price_to_currency(
                                                                            Number(
                                                                                reserva.precio_alquiler,
                                                                            ),
                                                                        ),
                                                                    )}{" "}
                                                                    {
                                                                        SELECTED_CURRENCY
                                                                    }
                                                                </span>
                                                            </div>
                                                            <div className="flex w-full mt-4 ">
                                                                {
                                                                    <ModalCupon
                                                                        setCupon={
                                                                            setCupon
                                                                        }
                                                                        cupon={
                                                                            cupon
                                                                        }
                                                                    />
                                                                }
                                                            </div>
                                                            {reserva.descuento_estadia ? (
                                                                <div className="flex justify-between w-full mt-4 font-semibold text-green-600">
                                                                    <span className="">
                                                                        Descuento
                                                                        por
                                                                        larga
                                                                        estadía{" "}
                                                                    </span>
                                                                    <span className="font-medium text-end min-w-max">
                                                                        -{" "}
                                                                        {formatearNumero(
                                                                            Number(
                                                                                price_to_currency(
                                                                                    reserva.descuento_estadia,
                                                                                ),
                                                                            ),
                                                                        )}{" "}
                                                                        {
                                                                            SELECTED_CURRENCY
                                                                        }
                                                                    </span>
                                                                </div>
                                                            ) : null}

                                                            {Number(
                                                                reserva.garantia,
                                                            ) !== 0 &&
                                                                (habitacion.tipo_garantia ===
                                                                    "Alquiler" ||
                                                                    habitacion.tipo_garantia ===
                                                                        null) && (
                                                                    <div
                                                                        className={`flex justify-between w-full py-2 ${textAccentClass} font-semibold transition-colors duration-300`}
                                                                    >
                                                                        <span className="mt-2 ">
                                                                            Garantia{" "}
                                                                        </span>
                                                                        <span className="mt-2 ">
                                                                            {formatearNumero(
                                                                                price_to_currency(
                                                                                    Number(
                                                                                        reserva.garantia,
                                                                                    ),
                                                                                ),
                                                                            )}{" "}
                                                                            {
                                                                                SELECTED_CURRENCY
                                                                            }
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            {reserva
                                                                .servicios_adicionales
                                                                ?.length !==
                                                                0 && (
                                                                <div
                                                                    className={`flex flex-col w-full gap-1 mt-4 text-left border-t ${borderAccentClass} ${textAccentClass} font-semibold transition-colors duration-300`}
                                                                >
                                                                    <span className="mb-2 font-semibold ">
                                                                        Servicios
                                                                        adicionales
                                                                    </span>
                                                                    {reserva.servicios_adicionales?.map(
                                                                        (
                                                                            service,
                                                                        ) => (
                                                                            <div
                                                                                key={
                                                                                    service.id
                                                                                }
                                                                                className="flex items-center justify-between "
                                                                            >
                                                                                <div className="flex items-center gap-2">
                                                                                    <input
                                                                                        className={`w-4 h-4 cursor-pointer ${checkboxClass}`}
                                                                                        type={
                                                                                            "checkbox"
                                                                                        }
                                                                                        disabled={
                                                                                            service.opcional ===
                                                                                            "No"
                                                                                        }
                                                                                        checked={checkedInputs.includes(
                                                                                            service.id,
                                                                                        )}
                                                                                        value={
                                                                                            service.id
                                                                                        }
                                                                                        onChange={
                                                                                            handleCheckbox
                                                                                        }
                                                                                    />
                                                                                    <span>
                                                                                        {
                                                                                            service.nombre
                                                                                        }
                                                                                    </span>
                                                                                </div>

                                                                                {service.precio ? (
                                                                                    <span
                                                                                        className={
                                                                                            !checkedInputs.includes(
                                                                                                service.id,
                                                                                            )
                                                                                                ? "font-medium text-gray-300"
                                                                                                : "font-medium"
                                                                                        }
                                                                                    >
                                                                                        {formatearNumero(
                                                                                            Number(
                                                                                                price_to_currency(
                                                                                                    service.precio,
                                                                                                ),
                                                                                            ),
                                                                                        )}{" "}
                                                                                        {
                                                                                            SELECTED_CURRENCY
                                                                                        }{" "}
                                                                                    </span>
                                                                                ) : null}
                                                                            </div>
                                                                        ),
                                                                    )}
                                                                </div>
                                                            )}

                                                            <div
                                                                className={`flex flex-col justify-center items-center mt-4 w-full border-t ${borderAccentClass} transition-colors duration-300`}
                                                            >
                                                                <div className="flex justify-between items-center w-full text-[#666666] font-bold  pt-4 ">
                                                                    <span className="">
                                                                        ¿Desea
                                                                        tomar un
                                                                        tour?
                                                                    </span>
                                                                    <div
                                                                        onClick={() =>
                                                                            setView(
                                                                                "all_tours",
                                                                            )
                                                                        }
                                                                        className={`${bgButtonClass} text-white rounded-lg px-5 py-2 font-semibold hover:scale-105 transition-all duration-300 cursor-pointer`}
                                                                    >
                                                                        Ver
                                                                        tours
                                                                    </div>
                                                                </div>
                                                                <div className="w-full">
                                                                    {" "}
                                                                    {reserva.reserva_tours.map(
                                                                        (
                                                                            tour,
                                                                            index,
                                                                        ) => (
                                                                            <div>
                                                                                <div className="flex justify-between w-full mt-2 ">
                                                                                    <span className="font-semibold">
                                                                                        Tour
                                                                                    </span>
                                                                                    <div
                                                                                        onClick={() =>
                                                                                            handleDeleteTour(
                                                                                                tour,
                                                                                                index,
                                                                                            )
                                                                                        }
                                                                                        className="flex items-center justify-center gap-5 "
                                                                                    >
                                                                                        {
                                                                                            tour
                                                                                                .tour
                                                                                                .nombre
                                                                                        }{" "}
                                                                                        <div className="flex items-center justify-center text-white bg-red-300 rounded-full cursor-pointer h-7 w-7 hover:scale-105 hover:bg-red-500">
                                                                                            X
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="flex justify-between w-full mt-2 ">
                                                                                    <span className="font-semibold">
                                                                                        Turno
                                                                                    </span>
                                                                                    <span className="">
                                                                                        {formatearFecha(
                                                                                            tour.fecha,
                                                                                        )}{" "}
                                                                                        (
                                                                                        {agregarAMPM(
                                                                                            tour.hora_inicio,
                                                                                        )}{" "}
                                                                                        {
                                                                                            "-"
                                                                                        }
                                                                                        {agregarAMPM(
                                                                                            tour.hora_final,
                                                                                        )}

                                                                                        )
                                                                                    </span>
                                                                                </div>
                                                                                <div className="flex justify-between w-full mt-2 ">
                                                                                    <span className="font-bold">
                                                                                        Precio
                                                                                        Tour
                                                                                        por
                                                                                        persona
                                                                                    </span>
                                                                                    <span className="">
                                                                                        {formatearNumero(
                                                                                            tour.precio_tour_simple,
                                                                                        )}{" "}
                                                                                        {
                                                                                            SELECTED_CURRENCY
                                                                                        }{" "}
                                                                                        X
                                                                                        (
                                                                                        {Number(
                                                                                            tour
                                                                                                .personas
                                                                                                .adultos,
                                                                                        ) +
                                                                                            Number(
                                                                                                tour
                                                                                                    .personas
                                                                                                    .ninos,
                                                                                            )}{" "}
                                                                                        Personas)
                                                                                    </span>
                                                                                </div>
                                                                                <div className="flex justify-between w-full mt-2 ">
                                                                                    <span className="font-bold">
                                                                                        Precio
                                                                                        Tour
                                                                                    </span>
                                                                                    <span className="font-semibold">
                                                                                        {formatearNumero(
                                                                                            tour.precio_tour,
                                                                                        )}{" "}
                                                                                        {
                                                                                            SELECTED_CURRENCY
                                                                                        }
                                                                                    </span>
                                                                                </div>

                                                                                <hr
                                                                                    className={`my-4 ${borderAccentClass} transition-colors duration-300`}
                                                                                />
                                                                            </div>
                                                                        ),
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div
                                                                className={`flex justify-between w-full mt-4 text-[#666666] font-bold border-t ${borderAccentClass} pt-4 transition-colors duration-300`}
                                                            >
                                                                <span className="">
                                                                    Precio total
                                                                    de la
                                                                    reserva:{" "}
                                                                </span>
                                                                <span className="">
                                                                    {formatearNumero(
                                                                        Number(
                                                                            reserva.precio_total_reserva,
                                                                        ) -
                                                                            Number(
                                                                                cupon,
                                                                            ),
                                                                    )}{" "}
                                                                    {
                                                                        SELECTED_CURRENCY
                                                                    }
                                                                </span>
                                                            </div>

                                                            {Number(
                                                                reserva.garantia,
                                                            ) !== 0 &&
                                                                habitacion.tipo_garantia ===
                                                                    "Efectivo" && (
                                                                    <div className="flex w-full px-1 mt-4 bg-blue-200 border-4 border-blue-300 rounded-lg">
                                                                        <span className="underline">
                                                                            Garantía:{" "}
                                                                        </span>
                                                                        <span className="ml-2 italic font-thin ">
                                                                            Deberás
                                                                            pagar{" "}
                                                                            {formatearNumero(
                                                                                price_to_currency(
                                                                                    Number(
                                                                                        reserva.garantia,
                                                                                    ),
                                                                                ),
                                                                            )}{" "}
                                                                            {
                                                                                SELECTED_CURRENCY
                                                                            }{" "}
                                                                            en
                                                                            efectivo
                                                                            al
                                                                            momento
                                                                            de
                                                                            llegar
                                                                            a la
                                                                            propiedad.
                                                                            (Reembolsable)
                                                                        </span>
                                                                    </div>
                                                                )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}

            {view === "all_tours" &&
                (loading ? (
                    <>
                        <Spinner />
                    </>
                ) : (
                    <ModalHabitacionAllTours
                        tours={tours}
                        handleClick={handleClick}
                        setView={setView}
                    />
                ))}

            {view === "tour" && (
                <ModalHabitacionOneTour
                    id_tour={tourSelected?.id}
                    scrollRef={scrollRef}
                    setReserva={setReserva}
                    setView={setView}
                    landing="landing"
                />
            )}
        </ResponsiveModalAbsolute>
    );
};
